import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class SplitContainerContentTextConverter extends CmsConverterService<SplitContainerContentTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      label: formData.st_label ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
    }
  }
}

export const SPLIT_CONTAINER_CONTENT_TEXT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, SplitContainerContentTextData>>('SplitContainerContentTextConverter')

export interface SplitContainerContentTextData extends ConvertedComponentData {
  label: TextInput;
  headline: TextInput;
  text: TextInput;
}
